import templateUrl from './itemIdentifiers.html'

/**
 * Item Identifiers component
 *
 * Shows a list of identifiers (epcs, tags...) of an item
 *
 * @example
 * <tmr-item-identifiers item="item"></tmr-item-identifiers>
 *
 * @type {ngComponent}
 * @prop {Item} item
 */
export const tmrItemIdentifiers = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrItemIdentifiersController',
  bindings: {
    item: '<',
  },
}

/**
 * Controller of component {@link tmrItemIdentifiers}
 *
 * @type {ngController}
 */
export class tmrItemIdentifiersController {
  static ngType = 'controller'

  constructor(tmrIdentifierTypes) {
    'ngInject'
    Object.assign(this, { identifierTypes: tmrIdentifierTypes })
  }

  $onChanges({ item: { currentValue } }) {
    this.identifiers = currentValue?.$identifiers ?? []
  }
}
